import React from 'react';
import PropTypes from 'prop-types';

import { LinkSecondary } from '@klarna/bubble-ui';
import { analytics } from '../utils';

const ANALYTICS_EVENTS = {
  addMore: new analytics.Event({
    name: 'One Person Added',
    description: 'Merchant adds a person',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['path'],
  }),
};

const onClickWithAnalytics = onClick => {
  analytics.logEvent(ANALYTICS_EVENTS.addMore, { path: window.location.pathname.toString() });
  return onClick();
};

const AddMoreIfAllowed = ({
  onClick,
  text,
  currentCount,
  maxCount = Number.MAX_SAFE_INTEGER,
  ...props
}) =>
  currentCount < maxCount && (
    <LinkSecondary
      {...props}
      onClick={e => {
        e.preventDefault();
        onClickWithAnalytics(onClick);
      }}
    >
      {text}
    </LinkSecondary>
  );

AddMoreIfAllowed.propTypes = {
  currentCount: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  maxCount: PropTypes.number,
};

export default AddMoreIfAllowed;
